import { IonButtons, IonCol, IonContent, IonFooter, IonGrid
  , IonHeader, IonItem, IonLabel, IonMenuButton
  , IonPage, IonRow, IonTitle, IonToolbar ,IonCard
  , IonModal, IonButton, IonText, IonSpinner, IonIcon, IonAlert, IonBackButton} from '@ionic/react';
  import React, { useEffect, useState, useRef } from 'react';
  import { logInOutline, logOutOutline, calendarOutline, personCircleOutline, timeOutline, clipboardOutline, logOut } from 'ionicons/icons';
//import { useParams } from 'react-router';
import './Bams.css';
import OpenMenuButton from "../../../components/OpenMenuButton";
import ServerService from '../../../services/Server';
import MapContainer, { MapContainerRef } from '../../../components/MapContainer';
import { useIonRouter } from '@ionic/react';
import { Environment } from "../../../data/Environment";

const server = new ServerService();

const Con: React.FC = () => {
 const router = useIonRouter();


 const menus = [
  { title: 'ลงเวลางาน', icon: timeOutline, path: '/page/home/bams/checkInOut', color: '#3880ff' },
  { title: 'ปฏิทินงาน', icon: calendarOutline, path: '/page/home/bams/workCalendar', color: '#3880ff' },
  { title: 'รายการแผน', icon: clipboardOutline, path: '/page/home/bams/checkInOut', color: '#3880ff' },
];

 return (
 
  <IonPage>
  <IonHeader className="blue-header">
  <IonToolbar color="primary">
    <IonButtons slot="start">
      <IonMenuButton />
      <OpenMenuButton />
    </IonButtons>

    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'space-between', 
      width: '100%',
      padding: '0 16px' 
    }}>
      
     
      <div style={{ flex: 1, textAlign: 'left' }}>
        <IonText style={{ fontSize: '0.85rem', opacity: 0.9 }}>
          
        </IonText>
      </div>

     
      <div style={{ flex: 2, textAlign: 'center' }}>
        <IonText style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>
          หน้าหลัก
        </IonText>
      </div>

     
      <div style={{ flex: 1, textAlign: 'right' }}>
        {/* <IonIcon icon={personCircleOutline} style={{ fontSize: '24px' }} /> */}
      </div>
      
    </div>
    <IonButtons slot="end">
      {(server.state.logout == "1") && (
        <IonButton size="large" onClick={e => {
                          server.logout();
                          window.location.href = "/page/login";
        }}><IonIcon icon={logOut}></IonIcon></IonButton>
      )}
    </IonButtons>
  </IonToolbar>
</IonHeader>
  {/* <IonContent className="ion-padding gray-bg">*/}
  <IonContent className="ion-padding gray-bg">
    <IonGrid>
      <IonRow>
        {menus.map((menu, index) => (
          <IonCol size="6" key={index}>
            <IonCard 
              className="menu-card" 
              onClick={() => router.push(menu.path)}
              style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center', 
                justifyContent: 'center',
                padding: '20px',
                margin: '8px',
                borderRadius: '15px',
                boxShadow: 'none', 
                border: '1px solid #d1d1d1', 
                height: '140px'
              }}
            >
              <IonIcon 
                icon={menu.icon} 
                style={{ fontSize: '40px', color: menu.color, marginBottom: '10px' }} 
              />
              <IonText style={{ fontWeight: 'bold', fontSize: '1rem' }}>
                {menu.title}
              </IonText>
            </IonCard>
          </IonCol>
        ))}
      </IonRow>
    </IonGrid>
  </IonContent>
</IonPage>

 );
};

export default Con;
